import React from 'react';
import { Nav } from 'reactstrap';
import { NavLink as RouterNavLink } from 'react-router-dom';
import './SettingsNav.scss';

export type SettingsNavItem = {
    url: string;
    title: string;
};

export class SettingsNav extends React.Component<{ navItems: SettingsNavItem[] }> {
    render() {
        return (
            <Nav className="settingsNav">
                {this.props.navItems.map((nav) => (
                    <li key={nav.url}>
                        <RouterNavLink
                            to={nav.url}
                            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                        >
                            {nav.title}
                        </RouterNavLink>
                    </li>
                ))}
            </Nav>
        );
    }
}
